import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

const KenSmallLoader = ({
  height = '25',
  width = '25',
  radius = '9',
  color = '##272727',
}) => {
  return (
    <ThreeDots
      height={height}
      width={width}
      radius={radius}
      color={color}
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClassName=""
      visible={true}
    />
  );
};

export default KenSmallLoader;
